module.exports = __webpack_public_path__ + "87e0b7fa.png";